import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { TelecallerSlotMasterService } from '../../../services/index';
import { AddEditTelecallerSlotComponent } from './addEditTelecallerSlot.component';

@Component({
    selector: 'telecaller-slot-master-tab',
    templateUrl: './telecallerSlotMaster.component.html'
})
export class TelecallerSlotMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('slotTable') slotTable: any;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('statusTemplate') statusTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    slotList: any[] = [];
    isLoadMask: Promise<any>;
    loadingIndicator = true;
    reorderable = true;
    bsModalRef: BsModalRef;

    filterData = { search_data: '' };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'order_no',
        orderDir: 'asc'
    };

    constructor(
        private telecallerSlotMasterService: TelecallerSlotMasterService,
        private modalService: BsModalService,
        private toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Slot Name', prop: 'slot_name', width: 250, minWidth: 250, maxWidth: 250 },
            { name: 'Order No', prop: 'order_no', width: 120, minWidth: 120, maxWidth: 120, cellClass: 'cell-center' },
            { name: 'Status', prop: 'status', width: 130, minWidth: 130, maxWidth: 130, cellTemplate: this.statusTemplate },
            { name: 'Action', prop: 'slot_id', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getSlotList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[] }) {
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.getSlotList();
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getSlotList();
    }

    onOpenedFilter(): void {
        setTimeout(() => { $('#slotFilterSearch').focus(); }, 100);
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.page.offset = 0;
        this.getSlotList();
    }

    getSlotList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        this.isLoadMask = this.telecallerSlotMasterService.getSlotList(params)
            .then((res: any) => {
                this.loadingIndicator = false;
                this.page.count = res.totCnt;
                this.slotList = res.data;
            });
    }

    onAddEditSlot(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditTelecallerSlotComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-md maxWidthPer-40'
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = (mode === 'Add' ? 'Add' : 'Edit') + ' Telecaller Slot';
        this.bsModalRef.content.slotdata = Object.assign({}, row);
        this.bsModalRef.content.slotUpdateEvent.subscribe(() => {
            that.getSlotList();
        });
    }

    onDeleteSlot(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'Slot: ' + row.slot_name,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then((result) => {
            if (result.value) {
                that.telecallerSlotMasterService.deleteSlot({ slot_id: row.slot_id })
                    .then((res: any) => {
                        if (res.success) {
                            swal('Deleted', res.message, 'success');
                            that.getSlotList();
                        } else {
                            swal('Warning', res.message, 'warning');
                        }
                    });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/telecallerSlotMaster/telecallerSlotMaster.component.ts